<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="类型">
        <el-select v-model="dataForm.type" placeholder="请选择类型" style="width: 100%">
          <el-option
            v-for="item in optionType"
            :key="item.type"
            :label="item.name"
            :value="item.type">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="枚举名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="枚举名称"></el-input>
      </el-form-item>
      <el-form-item label="枚举值" prop="value">
        <el-input v-model="dataForm.value" placeholder="枚举值"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        type: '',
        name: '',
        value: ''
      },
      optionType: [],
      dataRule: {
        type: [
          {required: true, message: '类型不能为空', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '枚举名称不能为空', trigger: 'blur'}
        ],
        value: [
          {required: true, message: '枚举值不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init(id) {
      this.getOptionType();
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/configOption/list`),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/configOption/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'type': this.dataForm.type,
              'name': this.dataForm.name,
              'value': this.dataForm.value
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
            this.$message({
              message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取类型
    getOptionType() {
      this.$http({
        url: this.$http.adornUrl("/configOption/type/list"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.optionType = data.data.rows
        }
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/configoption-add-or-update.vue